import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {performSimpleActionForTable} from 'modules/data/data-actions';
import {ERequestType} from 'shared/types/requests';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

export const ButtonActionForTable: FC<ITableActionProps> = ({
    wrapper,
    meta,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();
    const entityName = meta?.entityName || '';
    const referenceUrl = meta?.referenceUrl || '';
    const requestType = meta?.requestType || ERequestType.DELETE;
    const handleClick = () => {
        dispatch(performSimpleActionForTable(entityName, referenceUrl, requestType));
    };
    const Component = wrapper || ActionButton;

    return (
        <Component
            {...props}
            actionIcon={meta.actionIcon}
            onClick={handleClick}
        >
            {meta.actionTitle}
        </Component>
    );
};
